import { createBrowserHistory } from 'history';

/**
 * React router history.
 *
 * Creating and providing it manually, so we can access it outside of components.
 */
export const history = createBrowserHistory({
    basename: process.env.PUBLIC_URL,
});
